import { useClientDocumentGroup } from 'api/requests';
import { ClientDocumentGroupName } from 'api/types/data';
import { ClientEntity } from 'api/types/entity';
import { ServerError } from 'api/types/error';

import { useSigningDocumentGroup } from './useSigningDocumentGroup';

export const useClientSigningDocumentGroup = (
  client: ClientEntity,
  documentGroupName: ClientDocumentGroupName,
  signDocumentGroup: (clientId: string, otpCode: string) => Promise<any>,
  submitError: ServerError | undefined
) => {
  const { documentGroup, loading } = useClientDocumentGroup(
    client.id,
    documentGroupName
  );

  const handleSignDocumentGroup = async (
    documentGroupId: string,
    otpCode: string
  ) => signDocumentGroup(client.id, otpCode);

  const { documents, formError, onClickDocument, onSubmit } =
    useSigningDocumentGroup({
      signDocumentGroup: handleSignDocumentGroup,
      documentGroup,
      submitError,
    });

  return {
    documents,
    loading,
    formError,
    onClickDocument,
    onSubmit,
  };
};
